import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { S3 } from 'aws-sdk';
import { saveAs } from 'file-saver';
import { DATETIME_FORMAT_FILE_PREFIX_S3, HTTP_HEADER_ESC_TIMEZONE } from '../../utils/constant';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class S3Service {

  constructor(
    public authService: AuthService,
    
  ) { }

  public download({ bucketName, key, filename }: { bucketName: string, key: string, filename?: string }, callback: (err?, data?: any) => void) {
    this.authService.checkAWSCredentials((err) => {
      if (err) {
        return callback(err);
      }

      let bucket = new S3({ region: environment.region });

      let params = {
        Bucket: environment.bucketName,
        Key: key
      };
      bucket.getObject(params, (err, data) => {
        if (err) {
          return callback(err);
        }
        saveAs(new Blob([data.Body as any], { type: data.ContentType }), filename);
        callback(null, data);
      });
    });
  }

  public upload({ folderName, file, options }: { folderName: string, file: File, options?: S3.ManagedUpload.ManagedUploadOptions },
    callback: (err?, s3Key?: any) => void
  ) {
    let self = this;
    this.authService.checkAWSCredentials((err) => {
      if (err) {
        return callback(err);
      }

      let bucket = new S3({ region: environment.region });

      // let extraPrefix = bucketName;
      let kebabFilename = _.kebabCase(file.name);
      let now = moment().format(DATETIME_FORMAT_FILE_PREFIX_S3);
      let extension = "." + getFileExtension(kebabFilename);

      function getFileExtension(fileName) {
        let ext = fileName.split('-');
        return ext[ext.length - 1];
      }

      let key = `${now}-${kebabFilename}-${extension}`;

      let params = {
        Bucket: folderName ? (environment.bucketName + '/' + folderName) : environment.bucketName,
        Key: key,
        Body: file,
        ContentType: file.type,
        ContentDisposition: "attachment; filename=" + encodeURIComponent(file.name),
        Metadata: {
          'user-id': localStorage.getItem("userId"),
          'upload-subfolder': folderName,
          'filename': file.name,
          'schema-name': localStorage.getItem("schemaName"),
          'timezone_sql': this.getUTC(),
          'original-filename': encodeURIComponent(file.name),
          [HTTP_HEADER_ESC_TIMEZONE]: localStorage.getItem("escTimezone")
        }
      };

      if (environment.showLogs) {
        console.log("S3 uploading params: ", params);
      }

      bucket.upload(params, options, (err) => {
        if (err) {
          return callback(err);
        }
        callback(null, key);
      });
    });
  }
 
  private getUTC() {
    let utc = new Date().getTimezoneOffset() / 60;
    let utcString;
    if(utc <= 0) {
      if(utc > -10) {
        utcString = "+0" + Math.abs(utc) + ":00";
      } else {
        utcString = "+" + Math.abs(utc) + ":00";
      }
    } else {
      if(utc < 10) {
        utcString = "-0" + Math.abs(utc) + ":00";
      } else {
        utcString = "-" + Math.abs(utc) + ":00";
      }
    }
    return utcString;
  }
}
